import React from "react"

const Dialaxylogo = () => {
  return (
    <svg
      width="160"
      height="40"
      viewBox="0 0 160 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4024_581)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.5216 3.41016H26.4442L16.9492 37.5243H28.0267L37.5216 3.41016ZM19.4784 19.5018H8.45854L3.40625 37.5244H14.4262L19.4784 19.5018Z"
          fill="#159946"
        />
        <path
          d="M47.3335 33.1206V10.5029H55.5491C62.6338 10.5029 67.0575 14.7936 67.0575 21.845C67.0575 28.8964 62.6338 33.1206 55.5491 33.1206H47.3335ZM55.5491 29.4951C59.9063 29.4951 62.5007 26.6679 62.5007 21.845C62.5007 16.9888 59.9063 14.1284 55.5491 14.1284H51.8238V29.4951H55.5491Z"
          fill="#24282E"
        />
        <path
          d="M70.5193 13.2968V9.17244H74.7768V13.2968H70.5193ZM70.5193 33.1206V15.2925H74.7768V33.1206H70.5193Z"
          fill="#24282E"
        />
        <path
          d="M82.7967 21.1465H78.506C79.0714 17.1884 81.9651 14.7936 86.4554 14.7936C91.4114 14.7936 93.9393 17.7206 93.9393 21.845V28.7633C93.9393 30.9586 94.1388 32.1892 94.4715 33.1206H90.0477C89.8148 32.5219 89.7151 31.6571 89.6818 30.6925C88.2183 32.7547 86.023 33.6195 83.8943 33.6195C80.4019 33.6195 77.9073 31.8899 77.9073 28.464C77.9073 26.0359 79.271 24.2065 81.9984 23.3085C84.36 22.5102 86.655 22.3106 89.6485 22.2774V21.845C89.6485 19.55 88.5509 18.3193 86.1894 18.3193C84.1604 18.3193 83.0628 19.4502 82.7967 21.1465ZM82.198 28.2311C82.198 29.5949 83.2623 30.4597 84.9919 30.4597C87.6196 30.4597 89.6485 28.3309 89.6485 25.67V24.905C83.595 25.0048 82.198 26.435 82.198 28.2311Z"
          fill="#24282E"
        />
        <path
          d="M97.999 33.1206V9.17244H102.256V33.1206H97.999Z"
          fill="#24282E"
        />
        <path
          d="M110.276 21.1465H105.986C106.551 17.1884 109.445 14.7936 113.935 14.7936C118.891 14.7936 121.419 17.7206 121.419 21.845V28.7633C121.419 30.9586 121.618 32.1892 121.951 33.1206H117.527C117.295 32.5219 117.195 31.6571 117.161 30.6925C115.698 32.7547 113.503 33.6195 111.374 33.6195C107.882 33.6195 105.387 31.8899 105.387 28.464C105.387 26.0359 106.751 24.2065 109.478 23.3085C111.84 22.5102 114.135 22.3106 117.128 22.2774V21.845C117.128 19.55 116.031 18.3193 113.669 18.3193C111.64 18.3193 110.542 19.4502 110.276 21.1465ZM109.678 28.2311C109.678 29.5949 110.742 30.4597 112.472 30.4597C115.099 30.4597 117.128 28.3309 117.128 25.67V24.905C111.075 25.0048 109.678 26.435 109.678 28.2311Z"
          fill="#24282E"
        />
        <path
          d="M136.521 33.1206L133.195 28.1314L132.364 26.5348L131.499 28.1314L128.273 33.1206H123.683L130.035 23.9072L124.148 15.2925H129.171L131.998 19.6497L132.863 21.2795L133.727 19.6497L136.521 15.2925H141.078L135.191 23.9072L141.544 33.1206H136.521Z"
          fill="#24282E"
        />
        <path
          d="M145.465 40.937C144.6 40.937 143.702 40.7041 143.269 40.5378V37.2782H144.267C146.196 37.2782 147.094 36.8791 148.458 33.4864L148.891 32.3888L141.872 15.2925H146.429L150.387 25.6368L151.119 28.2311L151.851 25.6368L155.643 15.2925H160L152.15 34.8834C150.321 39.5067 148.724 40.937 145.465 40.937Z"
          fill="#24282E"
        />
      </g>
      <defs>
        <clipPath id="clip0_4024_581">
          <rect width="160" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Dialaxylogo
